import { ComponentType } from 'react';
import * as Sentry from '@sentry/react';

export default function lazyRetry<T extends ComponentType<any>>(
    componentImport: () => Promise<{ default: T }>,
    chunkIdentifier: string
) {
    const sessionStorageKey = `retry-lazy-refreshed-${chunkIdentifier}`;

    return new Promise<{ default: T }>((resolve, reject) => {
        // check if the window has already been refreshed due to this chunk
        const hasRefreshed = JSON.parse(
            window.sessionStorage.getItem(sessionStorageKey) || 'false'
        );

        // try to import the component
        componentImport()
            .then((component) => {
                // success so reset the refresh state
                window.sessionStorage.setItem(sessionStorageKey, 'false');
                resolve(component);
            })
            .catch((error) => {
                if (!hasRefreshed) {
                    // not been refreshed yet
                    window.sessionStorage.setItem(sessionStorageKey, 'true');
                    Sentry.captureException(error);
                    // refresh the page
                    return window.location.reload();
                }

                // Default error behaviour as already tried refresh
                reject(error);
            });
    });
}
